
import "../styles/global.scss"
import "../styles/styles.scss"

import { animate, inView, stagger } from "motion"
import PhotoSwipeLightbox from 'photoswipe/lightbox'
import 'photoswipe/style.css'
import MiniMasonry from "minimasonry"


function adjustViewPortHeight() {
    document.documentElement.style.setProperty('--viewport-height', `${window.visualViewport.height}px`)
}

adjustViewPortHeight();
window.addEventListener('resize', () => { adjustViewPortHeight(); });


// Lightbox
const lightbox = new PhotoSwipeLightbox({
    gallery: '.lm-gallery',
    children: '.image a',
    pswpModule: () => import('photoswipe')
})
lightbox.init();

// WooCommerce Lightbox
const WOOlightbox = new PhotoSwipeLightbox({
    gallery: '.woo-lm-gallery',
    children: '.woocommerce-product-gallery__image a',
    pswpModule: () => import('photoswipe')
})
WOOlightbox.init();

// WordPresss Gallery Lightbox
const WPlightbox = new PhotoSwipeLightbox({
    gallery: '#content',
    children: '.wp-block-image a',
    pswpModule: () => import('photoswipe')
})
WPlightbox.init();


// Animations
var animationSelector = ".wp-block-image, .wp-block-group, .wp-block-gallery, .wp-block-paragraph, .wp-block-heading, #content h1, .wp-block-list, .wp-block-jeremybasolo-faq-block, .product-teaser, .entry-summary, .entry-images, .teaser, .hero div, .card"
var css = animationSelector + ', .lm-gallery .image { opacity: 0; }';


if(document.querySelector('.lm-gallery')) {

    // Masonry
    window.addEventListener("load", (event) => {

        var baseWidth = 240

        if($(window).width() < 600) {
            baseWidth = 130
        }
        
        var masonry = new MiniMasonry({
            container: '.lm-gallery',
            baseWidth: baseWidth,
            gutter: 20
        })

        masonry.layout()
        
    })
}


    

if(document.querySelector('#main-hero .card')) {
    
    document.querySelector('#main-hero .card').classList.add('is-visible')

}

inView(animationSelector, (element) => {
    element.classList.add('is-visible');
})




if(document.body.classList.contains('home')) {
    function adjustMainNav() {
        if(window.scrollY > 40) {
            document.getElementById('main-header').classList.add('no-hero');
        } else {    
            if(!document.getElementById('nav-main-mobile').classList.contains('active')) {
                document.getElementById('main-header').classList.remove('no-hero');
            }
        }
    }
    adjustMainNav()
    window.addEventListener("scroll", (event) => {
        adjustMainNav()
    })
}

document.getElementById('menu-trigger').addEventListener('click', (ev) => {
    ev.currentTarget.classList.toggle('is-active')
    document.getElementById('nav-main-mobile').classList.toggle('active')
    if(document.body.classList.contains('home')) {
        if(document.getElementById('nav-main-mobile').classList.contains('active')) {
            document.getElementById('main-header').classList.add('no-hero');
        } else {
            if(window.scrollY < 40) {
                document.getElementById('main-header').classList.remove('no-hero');
            }
        }
    }
})

if(document.getElementById('scroll-down')) {
    document.getElementById('scroll-down').addEventListener('click', (ev) => {
        var scrollTo = document.getElementById('content-container').offsetTop
        scrollTo = scrollTo - document.getElementById('main-header').clientHeight
        window.scrollTo({
            top: scrollTo,
            left: 0,
            behavior: "smooth",
          });
          
    })
}

setTimeout(() => {
    document.querySelectorAll('.cart-mini-contents .count').forEach((element) => {
        if(Number(element.textContent) > 0) {
            element.classList.add('active')
        } else {
            element.classList.remove('active')
        }
    })
}, 350)

document.addEventListener("DOMContentLoaded", function() {
	var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
  
	if ("IntersectionObserver" in window) {
	  var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
		entries.forEach(function(video) {
		  if (video.isIntersecting) {
			for (var source in video.target.children) {
			  var videoSource = video.target.children[source];
			  if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
				videoSource.src = videoSource.dataset.src;
			  }
			}
  
			video.target.load();
			video.target.classList.remove("lazy");

			video.target.nextElementSibling.addEventListener('click', function(ev) {
				ev.preventDefault();
				video.target.muted = !video.target.muted;
				this.classList.toggle('active');
			});

			lazyVideoObserver.unobserve(video.target);
		  }
		});
	  });
  
	  lazyVideos.forEach(function(lazyVideo) {
		lazyVideoObserver.observe(lazyVideo);
	  });
	}
});


// Infinite scroll pagination
if (document.querySelector(".teaser-grid") && document.querySelector(".pagination")) {
    
	var loading = false;
    window.onscroll = function (ev) {
        if ($(".pagination .next a").length > 0) {
            if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 150 && loading == false) {
                loading = true;
                var nextPage = document.querySelector(".pagination .next a").href;
                // document.querySelector(".teaser-grid").innerHTML = document.querySelector(".teaser-grid").innerHTML + 
                document.querySelector(".teaser-grid").insertAdjacentHTML("afterend", `
                    <div class="loading flex justify-center mb-10 items-center">
                        <svg aria-hidden="true" class="w-8 h-8 text-neutral-400 animate-spin fill-black" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                        </svg>
                        <span class="sr-only">Loading...</span>
                    </div>
                `);
                document.querySelector(".pagination").remove();

                fetch(nextPage)
                .then(response => response.text())
                .then(html => {
                    
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, "text/html");
                    const newArticles = doc.querySelector(".teaser-grid");

                    if (newArticles) {
                        const loadingEl = document.querySelector(".loading");
                    
                    if (loadingEl) loadingEl.remove();
                        const articlesContainer = document.querySelector(".teaser-grid");
                        articlesContainer.insertAdjacentHTML("beforeend", newArticles.innerHTML);
                        inView(animationSelector, (element) => {
                            animate(element, { 
                                opacity: 1, 
                                transform: ['translateY(20px)', 'translateY(0)'] 
                            }, { duration: .35, delay: 0.15 })
                        })
                    }

                    // Check if there is a next page
                    if (doc.querySelector(".pagination .next a")) {
                        document.querySelector(".pagination-block").innerHTML = doc.querySelector(".pagination-block").innerHTML;
                        loading = false;
                    }
                })
                .catch(error => {
                    console.error("Error loading next page:", error);
                });

            }
        }
    };
} 